// Deep link from the service-log reminder push: "#log/<zenotiAppointmentId>/<serviceId>".
// Producer: backend/lib/service-log-reminders.js reminderDeepLinkUrl().
// Scoped to this one link — the ops app has no general router (App.js owns a
// staffView string); this mirrors StaffReporting.jsx's per-feature hash use.

export function parseLogHash(hash) {
  const m = /^#log\/([^/]+)\/([^/]+)$/.exec(hash || '');
  if (!m) return null;
  try {
    return { appointmentId: decodeURIComponent(m[1]), serviceId: decodeURIComponent(m[2]) };
  } catch {
    return null; // malformed percent-encoding (e.g. truncated %XX)
  }
}

// Remove the #log hash without adding a history entry, so refresh/back
// doesn't replay the deep link.
export function clearLogHash() {
  if (/^#log\//.test(window.location.hash)) {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }
}
